export default "__VITE_ASSET__BDVSp2G4__"